import * as React from "react";
import type { SVGProps } from "react";
const SvgDeposit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#deposit_svg__a)">
      <path d="M22 20H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1.87a1 1 0 0 1 0 2H3v1h18v-1h-1.32a1 1 0 0 1 0-2H22a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1" />
      <path d="M17.29 20a1 1 0 0 1-.66-1.75 7 7 0 1 0-9.26 0 1 1 0 1 1-1.32 1.5 9 9 0 1 1 11.9 0 1 1 0 0 1-.66.25" />
      <path d="M11.74 18c-2.32 0-4.2-2.24-4.2-5s1.88-5 4.2-5a3.8 3.8 0 0 1 2.6 1.07A1 1 0 0 1 13 10.53a1.84 1.84 0 0 0-1.26-.53c-1.19 0-2.2 1.37-2.2 3s1 3 2.2 3a1.84 1.84 0 0 0 1.26-.53 1 1 0 0 1 1.36 1.46A3.8 3.8 0 0 1 11.74 18" />
      <path d="M10.94 12.8h-3.2a1 1 0 0 1 0-2h3.2a1 1 0 1 1 0 2M10.94 15.2h-3.2a1 1 0 1 1 0-2h3.2a1 1 0 0 1 0 2" />
    </g>
    <defs>
      <clipPath id="deposit_svg__a">
        <path fill="#fff" d="M1 4h22v16H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDeposit;
